import { MenuItem } from '@mui/material';
import { styled } from '@mui/system';

const MainMenuItem = styled(MenuItem)({
  padding: '2px 48px',
});

const MenuLinkItem = styled('a')({
  fontFamily: 'Raleway',
  fontWeight: 400,
  fontSize: '17px',
  color: '#fff',
  textDecoration: 'none',
  width: '100%',
  lineHeight: '48px',
});

const MainMenuContainer = styled('ul')({
  padding: '0',
  margin: '77px 0 20px',
});

const MainMenuItems = () => {
  return (
    <MainMenuContainer>
      <MainMenuItem>
        <MenuLinkItem href="/search">Find a Cafe</MenuLinkItem>
      </MainMenuItem>
      <MainMenuItem>
        <MenuLinkItem href="/note/gallery">Note Explorer</MenuLinkItem>
      </MainMenuItem>
      <MainMenuItem>
        <MenuLinkItem href="/">Coffee Beans Catalog</MenuLinkItem>
      </MainMenuItem>
    </MainMenuContainer>
  );
};
export default MainMenuItems;
